import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "shadow sm:rounded-t-md sm:overflow-hidden" };
const _hoisted_2 = { class: "bg-white py-6 px-4 space-y-6 sm:p-6" };
const _hoisted_3 = /*#__PURE__*/ _createElementVNode("div", null, [
    /*#__PURE__*/ _createElementVNode("h3", { class: "text-lg leading-6 font-medium text-gray-900" }, "\n            Organisation Details\n          ")
], -1);
const _hoisted_4 = ["innerHTML"];
const _hoisted_5 = ["innerHTML"];
const _hoisted_6 = /*#__PURE__*/ _createElementVNode("p", { class: "text-sm text-red-700" }, "*The Employing Entity will be the EQUANS company that Cost\n            Centre or Cost Object (Internal Order/WBS code) relates to.\n            Please check with your local Finance support if you are unsure of\n            this\n        ", -1);
const _hoisted_7 = ["innerHTML"];
const _hoisted_8 = ["innerHTML"];
const _hoisted_9 = /*#__PURE__*/ _createElementVNode("p", { class: "text-sm text-red-700" }, "*Please ensure this Cost Code has been validated by your local\n            Finance support before submitting this form\n        ", -1);
import { Input } from '@/form';
export default /*#__PURE__*/ _defineComponent({
    __name: 'organisationDetails',
    props: {
        formData: {},
        disableForm: { type: Boolean }
    },
    setup(__props) {
        const props = __props;
        const business_contract = Input('What is the name of the Business Contract that this role will be working on? *', 'business_contract', 'text', props.disableForm, props.formData.businesscontact);
        const employing_entity = Input('Which employing entity will this role be employed in? *', 'employing_entity', 'text', props.disableForm, props.formData.employedin);
        const division = Input('Which division will this role be employed in?  *', 'division', 'text', props.disableForm, props.formData.division);
        const cost_center = Input('Which cost centre will this role be assigned to? *', 'cost_center', 'text', props.disableForm, props.formData.assigned);
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("form", null, [
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _hoisted_3,
                        _createTextVNode(),
                        _createElementVNode("div", { innerHTML: _unref(business_contract) }, null, 8, _hoisted_4),
                        _createTextVNode(),
                        _createElementVNode("div", { innerHTML: _unref(employing_entity) }, null, 8, _hoisted_5),
                        _createTextVNode(),
                        _hoisted_6,
                        _createTextVNode(),
                        _createElementVNode("div", { innerHTML: _unref(division) }, null, 8, _hoisted_7),
                        _createTextVNode(),
                        _createElementVNode("div", { innerHTML: _unref(cost_center) }, null, 8, _hoisted_8),
                        _createTextVNode(),
                        _hoisted_9
                    ])
                ])
            ]));
        };
    }
});
